module.exports = __webpack_public_path__ + "img/prospect2.659c4575.jpeg";